/*
 * BG Cart Drawer Extras
 * ====================================================
 * - "+ Add" / size pill clicks on upsell cards
 * - Auto-rotating accessory carousel (pauses on interaction)
 * - Free shipping bar fill: recomputed from live /cart.js so the
 *   green progress is always accurate after AJAX re-renders
 */

(function () {
  'use strict';

  async function bgAddToCart(variantId, button) {
    if (!variantId) return;

    if (button) {
      button.setAttribute('aria-busy', 'true');
      button.setAttribute('disabled', '');
    }

    try {
      const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: parseInt(variantId, 10), quantity: 1 }],
          sections: 'cart-drawer,cart-icon-bubble',
          sections_url: window.location.pathname,
        }),
      });

      const addData = await addResponse.json();

      if (!addResponse.ok) {
        console.error('[bg-cart-extras] Add failed:', addData);
        if (button) {
          button.removeAttribute('aria-busy');
          button.removeAttribute('disabled');
        }
        return;
      }

      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.renderContents === 'function' && addData.sections) {
        cartDrawer.renderContents({ id: addData.id, sections: addData.sections });
      } else if (cartDrawer && typeof cartDrawer.open === 'function') {
        cartDrawer.open();
      }

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'bg-cart-extras',
          productVariantId: variantId,
          cartData: addData,
        });
      }
    } catch (err) {
      console.error('[bg-cart-extras] Add to cart error:', err);
      if (button) {
        button.removeAttribute('aria-busy');
        button.removeAttribute('disabled');
      }
    }
  }

  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-bg-cart-add]');
    if (!button) return;
    if (button.hasAttribute('disabled')) return;
    if (button.getAttribute('aria-busy') === 'true') return;

    event.preventDefault();
    const variantId = button.getAttribute('data-variant-id');
    bgAddToCart(variantId, button);
  });

  // -----------------------------------------------------
  // Free shipping bar: set fill width from live cart total
  // -----------------------------------------------------
  let bgCartTotalCache = null;

  function bgApplyShippingFill(totalCents) {
    const bars = document.querySelectorAll('[data-bg-shipping-bar]');
    bars.forEach(function (bar) {
      const threshold = parseInt(bar.getAttribute('data-threshold-cents'), 10);
      if (!threshold || threshold <= 0) return;
      let pct = Math.round((totalCents / threshold) * 100);
      if (pct > 100) pct = 100;
      if (pct < 0) pct = 0;
      const fill = bar.querySelector('.bg-shipping-bar__fill');
      if (fill) fill.style.width = pct + '%';
    });
  }

  async function bgUpdateShippingBar() {
    const bars = document.querySelectorAll('[data-bg-shipping-bar]');
    if (!bars.length) return;
    // Paint instantly from cache if we have it, then refresh from network
    if (bgCartTotalCache !== null) bgApplyShippingFill(bgCartTotalCache);
    try {
      const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      const cart = await res.json();
      bgCartTotalCache = cart.total_price;
      bgApplyShippingFill(cart.total_price);
    } catch (e) {
      console.error('[bg-cart-extras] shipping bar update failed', e);
    }
  }

  // -----------------------------------------------------
  // Auto-rotating carousel
  // -----------------------------------------------------
  const AUTOPLAY_INTERVAL_MS = 2500;
  const PAUSE_AFTER_INTERACTION_MS = 6000;

  function bgInitCarousels() {
    const scrollers = document.querySelectorAll('[data-bg-cart-upsells-scroller][data-bg-autoplay="true"]');
    scrollers.forEach(function (scroller) {
      if (scroller._bgAutoplayInit) return;
      scroller._bgAutoplayInit = true;
      scroller._bgPauseUntil = 0;

      function pause() {
        scroller._bgPauseUntil = Date.now() + PAUSE_AFTER_INTERACTION_MS;
      }

      scroller.addEventListener('touchstart', pause, { passive: true });
      scroller.addEventListener('mouseenter', pause);
      scroller.addEventListener('wheel', pause, { passive: true });

      if (scroller._bgInterval) clearInterval(scroller._bgInterval);

      scroller._bgInterval = setInterval(function () {
        if (Date.now() < scroller._bgPauseUntil) return;
        if (scroller.offsetParent === null) return;

        const firstCard = scroller.firstElementChild;
        if (!firstCard) return;

        const gap = parseInt(getComputedStyle(scroller).columnGap || getComputedStyle(scroller).gap || '12', 10);
        const step = firstCard.offsetWidth + (isNaN(gap) ? 12 : gap);
        const maxScroll = scroller.scrollWidth - scroller.clientWidth;

        if (scroller.scrollLeft + step >= maxScroll - 4) {
          scroller.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          scroller.scrollBy({ left: step, behavior: 'smooth' });
        }
      }, AUTOPLAY_INTERVAL_MS);
    });
  }

  function bgRefreshAll() {
    bgInitCarousels();
    bgUpdateShippingBar();
  }

  if (document.readyState !== 'loading') {
    bgRefreshAll();
  } else {
    document.addEventListener('DOMContentLoaded', bgRefreshAll);
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      setTimeout(bgRefreshAll, 50);
    });
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('#cart-icon-bubble, .header__icon--cart, [aria-controls*="CartDrawer"], [aria-controls*="cart-drawer"]')) {
      setTimeout(bgRefreshAll, 100);
    }
  }, true);
})();
